(function($) {
    $(() => {

        function setMenu() {
            var nav = $('#menu');
            if ($(window).scrollTop() > 0) {
                nav.addClass('scrolled');
            } else {
                nav.removeClass('scrolled');
            }
        }

        setMenu();

		$(window).scroll(function() {
			setMenu();
		});
        

        /* Investments slider front page */
        $('.js-investment-slider').slick({
            infinite: false,
            arrows: true,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            appendArrows: $('.js-arrow-wrapper'),
            prevArrow:  $('.js-left-arrow'),
            nextArrow:  $('.js-right-arrow'),
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        dots: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                    }
                }
            ]
        });

        /* news slider on front page */
        $('.js-news-slider').slick({
            infinite: false,
            arrows: true,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            appendArrows: $('.js-arrow-wrapper-news'),
            prevArrow:  $('.js-left-arrow-news'),
            nextArrow:  $('.js-right-arrow-news'),
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        dots: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                    }
                }
            ]
        });

        /* news slider on front page */
        $('.js-hero-slider').slick({
            infinite: true,
            arrows: true,
            dots: true,
           
            vertical: true,
			verticalSwiping: true,
			slidesToShow: 1,
			slidesToScroll: 1,
            swipe: false,
			speed: 0,
			cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 8000,
            appendArrows: $('.js-arrow-wrapper-hero'),
            prevArrow:  $('.js-left-arrow-hero'),
            nextArrow:  $('.js-right-arrow-hero'),
        });

        var controller = new ScrollMagic.Controller();

        if($('.js-hero-slider').length) {
           /*  var position = $(window).width();
            if($(window).width() < 998){
                position /= 10;
            } */
    
            /* TweenMax.fromTo(".section-hero__decor", 1.9,
                {right: Math.round(position * 0.15)},
                {right: Math.round(position * 0.17), repeat: -1, yoyo: true, ease:Power1.easeInOut}
            ); */
        

            /* var scene = new ScrollMagic.Scene({
                        triggerElement: '.js-hero-slider',
                        triggerHook: 0.3,
                        duration: 1000,
                    })
                    .addTo(controller);
            
            var tween = TweenMax.to('.js-hero-slider h1', 0.9, {bottom: 200});
            
            scene.setTween(tween); */
        }

        if($('.js-anim-wrapper').length) {
            var scene2 = new ScrollMagic.Scene({
                triggerElement: '.js-anim-wrapper',
                triggerHook: 0.8,
                duration: 800,
            })
            .addTo(controller);
    
            var tween1 = TweenMax.to('.js-anim-1', 0.9, {right: '40px'});
            var tween2 = TweenMax.to('.js-anim-2', 0.6, {right: '40px'});
            
            scene2.setTween([tween1, tween2]);
        }


        var position = $(window).width();
        TweenMax.fromTo("#sus-anim-1", 1.9,
            {right: Math.round(position * 0.01)},
            {right: Math.round(position * 0.05), repeat: -1, yoyo: true, ease:Power1.easeInOut}
        );
        TweenMax.fromTo("#sus-anim-2", 2.1,
            {right: Math.round(position * 0.02)},
            {right: Math.round(position * 0.05), repeat: -1, yoyo: true, ease:Power1.easeInOut}
        );

        /* Match hight */
        $('.match-h').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-flex').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        });

        /* Gallery */
        if ($('.js-gallery').length) {
            baguetteBox.run('.js-gallery', {
                animation: 'fadeIn',
                noScrollbars: false,
                loop: true
            });
        }

    });
})(jQuery);
